import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../i18n";
import { RevealText, Reveal } from "./Reveal";

const FOUNDER =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_reformas-acero/artifacts/yp9h9mbu_WhatsApp%20Image%202026-08-05%20at%2019.43.24.jpeg";

export default function Historia() {
  const { t } = useLang();
  const h = t.historia;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-4%", "6%"]);

  return (
    <section id="historia" className="relative py-24 md:py-32 grain">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex items-center gap-3 mb-8">
          <span className="h-px w-10 bg-brand-orange" />
          <span className="text-xs md:text-sm font-bold tracking-[0.25em] uppercase text-brand-orange">{h.overline}</span>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <RevealText
              as="h2"
              text={h.title}
              className="font-display font-semibold tracking-tighter leading-[0.95] text-4xl md:text-5xl lg:text-6xl block"
            />
            <div className="mt-8 space-y-5 max-w-xl text-steel-300 text-base md:text-lg leading-relaxed">
              <Reveal delay={0.05}><p>{h.p1}</p></Reveal>
              <Reveal delay={0.1}><p>{h.p2}</p></Reveal>
              <Reveal delay={0.15}><p>{h.p3}</p></Reveal>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-4 max-w-lg">
              {h.stats.map((s, i) => (
                <Reveal key={i} delay={0.1 + i * 0.08}>
                  <div className="border-l border-border pl-4">
                    <div className="font-display text-3xl md:text-4xl font-semibold text-white">{s.n}</div>
                    <div className="mt-1 text-xs md:text-sm text-steel-400 leading-snug">{s.l}</div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative overflow-hidden">
              <motion.img
                style={{ y }}
                src={FOUNDER}
                alt="Hamilton"
                className="w-full h-[520px] md:h-[640px] object-cover object-top scale-105"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <div className="font-display text-2xl font-semibold">Hamilton</div>
                <div className="text-sm text-brand-orange font-medium tracking-wide">Fundador · Acero Construcciones y Reformas</div>
              </div>
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="mt-20 grid md:grid-cols-4 gap-px bg-border border border-border">
          {h.steps.map((step, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="bg-bg p-7 h-full group hover:bg-surface transition-colors duration-500">
                <div className="text-xs font-bold tracking-[0.2em] uppercase text-brand-orange">{step.year}</div>
                <div className="mt-4 font-display text-xl font-semibold">{step.t}</div>
                <p className="mt-3 text-sm text-steel-400 leading-relaxed">{step.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
